import listTemplate from './views/list.tpl.html';
import editorTemplate from './views/editor.tpl.html';
import BillingInvoiceTemplatesCreateController from './controllers/pages/create-controller';
import BillingInvoiceTemplatesEditController from './controllers/pages/edit-controller';

angular
    .module('festzelt-os.billing.invoice_templates')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.billing.invoice_templates', {
            abstract: true,
            url: 'invoices/templates',
            template: '<ui-view />',
            data: {
                pageTitle: 'Invoice Templates'
            }
        })
        .state('app.billing.invoice_templates.index', {
            url: '/',
            sticky: true,
            data: {
                right: 'billing::invoice_template-list',
                showBackBtn: false
            },
            templateUrl: listTemplate,
            controller: 'InvoiceTemplatesListCtrl',
            controllerAs: 'vm'
        })
        .state('app.billing.invoice_templates.create', {
            url: '/create',
            data: {
                right: 'billing::invoice_template-create',
            },
            params: {
                invoiceTemplate: undefined,
                store: undefined
            },
            templateUrl: editorTemplate,
            controller: BillingInvoiceTemplatesCreateController,
            controllerAs: 'vm'
        })
        .state('app.billing.invoice_templates.edit', {
            url: '/{id}/edit',
            params: {
                invoiceTemplate: undefined,
                store: undefined
            },
            data: {
                right: 'billing::invoice_template-edit',
            },
            templateUrl: editorTemplate,
            controller: BillingInvoiceTemplatesEditController,
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/invoice_templates-routes.js